<template>
  <div>
    <div class="account">
      <div class="account-left">
        <div class="account-left-container">
          <div class="avatar">
            <img :src="String(userInfo.avatar).trim() || '//static001-test.geekbang.org/resource/image/76/9b/768b32f8e804d8ba4c018f0a7033c09b.jpeg'">
          </div>
          <div class="nickname" v-if="baseInfo.name || userInfo.nick">
            {{ baseInfo.name || userInfo.nick }}
          </div>
        </div>
      </div>
      <div class="account-right">
        <div class="account-right-container">
          <!-- 招呼语 -->
          <div class="account-hello" v-if="baseInfo.name || userInfo.nick">
            {{`亲爱的 ${baseInfo.name || userInfo.nick} 您好`}}
          </div>

          <!-- TGO员工 -->
          <div
            class="account-info"
            v-if="baseInfo.admin === 1"
          >
            <span class="account-title">非 TGO 鲲鹏会会员（TGO 员工）</span>
          </div>

          <template v-else>
            <!-- 资料完整度 -->
            <div class="account-filesProcess" v-if="statusInfo.status===0||statusInfo.status===1">
              <span class="account-title">资料完整度：</span>
              <span class="account-processbar">
                <b class="file-bar">
                  <b class="file-bar-highlight" v-if="statusInfo.status===1"></b>
                </b>
                <b class="file-bar-word">{{statusInfo.status===0?'0%':'60%'}}</b>
              </span>
              <span class="account-warn">完善信息可提高审核通过率</span>
            </div>
            <!-- 成为 TGO 学员 -->
            <div class="account-member" v-if="statusInfo.status===8&&(statusInfo.explanation===1||statusInfo.explanation===-3)">
              <span class="account-member-container">
                <span class="iconfont">&#xe695;</span>
                <span class="account-member-line"></span>
                <b class="account-member-text">恭喜您成为 TGO 鲲鹏会学员</b>
              </span>
            </div>
            <!-- 进度条 -->
            <tgo-bar v-if="statusInfo.progress_rate && statusInfo.progress_rate===4" :statusInfo="statusInfo" @submit="submitModal"></tgo-bar>
            <!-- 状态信息 -->
            <div class="account-info" v-if="statusInfo.status===0||statusInfo.status===1||(statusInfo.status===8&&statusInfo.explanation===-2)">
              <span class="account-title">状态：</span>
              <span class="account-infoContent">{{statusWord}}</span>
              <a class="account-btn" :href="statusBtn.link" v-if="statusBtn.link!=='javacript:void(0)'">{{statusBtn.word}}</a>
              <span class="account-btn" v-else @click="showTip=true">{{statusBtn.word}}</span>
              <p class="account-join">
                当前剩余免费次数：{{(2 - ((baseInfo.join_count >= 2 ? 2 : baseInfo.join_count) || 0))}}/2 次
                <img @mouseenter="touchWarn = 'warn'" @mouseleave="touchWarn = ''" class="account-join-icon" src="https://static001.geekbang.org/resource/image/8f/22/8ff667e9e8yyb72376ee3beaa835e722.png" />
              </p>
              <div class="warn-content" v-if="touchWarn === 'warn'">
                <p class="warn-content-title">非学员权益</p>
                <p class="warn-content-text">所有非学员用户将会获得 <span class="warn-content-text-free">两次免费参与</span> TGO 付费活动的机会（需交纳保证金）。该权益将在首次和第二次报名活动时自动使用且不可取消。第三次起非学员报名活动时将按照活动价交费参加。</p>
              </div>
            </div>
            <div class="account-info" v-if="statusInfo.status===8&&statusInfo.explanation===-1">
              <span class="account-title">状态：</span>
              <span class="account-infoContent">{{statusWord}}</span>
            </div>
            <!-- 学员到期时间 -->
            <div class="account-info" v-if="statusInfo.status===8&&statusInfo.end_date">
              <span class="account-title">学员有效期：</span>
              <span class="account-infoContent">{{memberTimeDeadline}}</span>
              <a class="account-btn" :href="statusBtn.link" @click="showTip=true" v-if="statusInfo.explanation===-3">{{statusBtn.word}}</a>
            </div>
          </template>

          <!-- 弹窗 -->
          <modal-tip :show="showTip" @close="showTip=false">
            <!-- 重新审核弹窗 -->
            <div class="reaudit" v-if="modalUse==='reAudit'">
              <img src="//static001.geekbang.org/resource/image/3e/89/3ee15ed635a4fcda835cd517368e3489.jpg" alt="">
              <div class="wrapper">
                <div class="word">
                  信息已经转给运营团队审核，
                  <br>
                  1-2个工作日内给您回复，感谢您的耐心等待。
                </div>
                <div class="confirm" @click="reAudit">确认</div>
              </div>
            </div>
            <!-- 付款弹窗 -->
            <div class="show-tip" v-else>
              <i class="iconfont" @click="showTip=false">&#xe61e;</i>
              <div class="tip-title">付款方式</div>
              <hr>
              <!-- <div class="img">
                <img :src="fileModal" alt="">
              </div> -->
              <div class="word">
                <h3>付款方式一：</h3>
                <p>{{ offlinePayInfo.name }}</p>
                <p>{{ offlinePayInfo.bank }}</p>
                <p>开户账号：{{ offlinePayInfo.account }}</p>
                <h3>付款方式二：</h3>
                <p>{{ offlinePayInfo.alipayAccount }}</p>
              </div>
              <div class="confirm" @click="showTip=false">确认</div>
            </div>
          </modal-tip>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import tgoBar from './bar'
import modalTip from '@/base/modal'
import moment from 'moment'

import { offlinePayInfo } from '../../../service/basicData'

export default {
  data () {
    return {
      showTip: false,
      modalUse: '',
      touchWarn: '',
      offlinePayInfo: Object.freeze(offlinePayInfo)
    }
  },
  components: {
    tgoBar,
    modalTip
  },
  created () {},
  methods: {
    submitModal (v) {
      if (v) {
        this.modalUse = v
      }
      this.showTip = true
    },

    reAudit () {
      this.showTip = false
      this.statusInfo.explanation = 0
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
      statusInfo: 'applyStatusInfo',
      baseInfo: 'baseInfo'
    }),
    memberTimeDeadline () {
      return moment(Number(this.statusInfo.end_date) * 1000).format('YYYY-MM-DD')
    },
    statusWord () {
      if (this.statusInfo.status === 0) return '非 TGO 鲲鹏会学员'
      if (this.statusInfo.status === 1) return '暂不入会'
      if (this.statusInfo.status === 8) {
        if (this.statusInfo.explanation === -2) return '您的学员已过期'
        if (this.statusInfo.explanation === -3) return '即将过期'
        if (this.statusInfo.explanation === -1) return '您的账号已冻结'
        else return ''
      } else { return '' }
    },
    statusBtn () {
      if (this.statusInfo.status === 0) return { word: '申请入会', link: '/apply' }
      if (this.statusInfo.status === 1) return { word: '申请入会', link: '/apply' }
      if (this.statusInfo.status === 8) {
        if (this.statusInfo.explanation === -2 || this.statusInfo.explanation === -3) {
          return { word: '立即续费', link: 'javacript:void(0)' }
        } else {
          return {}
        }
      } else { return {} }
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

.account
  border-radius: 5px
  height: 270px
  color: #000
  display: flex
  justify-content: space-between
  background: url('https://static001.geekbang.org/resource/image/d9/1e/d96cc4d26b97759573326dbc066c371e.png') center / cover no-repeat
  .account-left
    width: 21%
    display: flex
    align-items: center
    justify-content: center
    .account-left-container
      display: flex
      flex-direction: column
      align-items: center
      margin-left: 40px
      .avatar
        border-radius: 50%
        overflow: hidden
        width: 122px
        height: 122px
        img
          width: 100%
          height: 100%
          vertical-align: middle
      .nickname
        color: $primary3
        margin-top: 22px
        font-size: 18px
        font-weight: 500
        text-align: center
  .account-right
    width: 77%
    display: flex
    padding: 46px 30px 30px 38px
    .account-right-container
      color: $primary3
      width: 100%
      // 招呼语
      .account-hello
        font-size: 28px
        font-weight: 700
        margin-bottom: 30px
        color: #caac70
      // 资料完整度
      .account-filesProcess
        margin-bottom: 20px
        display: flex
        align-items: center
        .account-processbar
          display: flex
          align-items: center
          .file-bar
            background-color: #535353
            height: 12px
            width: 156px
            border-radius: 6px
            .file-bar-highlight
              display: block
              background-color: #be9d65
              width: 94px
              height: 12px
              border-radius: 6px
          .file-bar-word
            margin: 0 5px
        .account-warn
          font-size: 14px
          margin-left: 10px
      // 成为学员
      .account-member
        display: flex
        align-items: center
        justify-content: center
        height: 36px
        width: 310px
        margin-bottom: 18px
        // background-color: #383838
        // background: rgba(209, 167, 95, 0.1)
        background: url('https://static001.geekbang.org/resource/image/3b/25/3b03323a00a699f0376603842b7c5e25.png') no-repeat center / cover
        // border-radius: 18px
        span.account-member-container
          display: flex
          align-items: center
          // padding: 6px 16px
          .iconfont
            font-size: 25px
            height: 27px
            margin-top: -10px
          .account-member-line
            display: inline-block
            // float: left
            width: 1px
            height: 20px
            margin: 0 10px
            background: $primary3
            font-weight: 400
          .account-member-text
            padding-top: 2px
            font-size: 18px
          b
            font-size: 20px
            font-weight: 400
            // margin: auto auto
      // 状态信息
      .account-info
        margin-bottom: 15px
        color: #D7B375
        font-weight: 500
        font-size: 14px

        .account-btn
          border: 1px solid #be9d65
          padding: 4px 12px
          border-radius: 5px
          margin: 0 15px
          color: #be9d65
          font-size: 14px
          cursor: pointer

        .account-join
          margin-top: 22px
          color: #D7B375
          font-size: 16px
          font-weight: 400
          line-height: 22px

        .account-join-icon
          width: 16px
          height: 16px
          margin-left: 14px
          vertical-align: sub

        .warn-content
          position: absolute
          width: 464px
          height: 130px
          padding: 25px
          margin-left: -13px
          background: url('https://static001.geekbang.org/resource/image/1b/f6/1bf1490be8ca6d489bf75597b001c0f6.png') center / cover no-repeat

        .warn-content-title
          margin-bottom: 10px
          color: #353535
          line-height: 16px
          font-size: 12px
          font-weight: 500

        .warn-content-text
          color: #888888
          line-height: 18px
          font-size: 12px
          font-weight: 400

        .warn-content-text-free
          color: #d1a75f

// 付费弹窗
.show-tip
  background: #fff
  width: 372px
  border-radius: 5px
  padding: 30px 42px
  position: relative
  i
    position: absolute
    right: 16px
    top: 7px
    font-size: 21px
    color: #888
    cursor: pointer
  .tip-title
    text-align: center
    font-weight: 700
    font-size: 18px
  hr
  .img
    position: relative
    margin: 0 auto
    width: 132px
    height: 132*1.17px
    border: 1px solid $primary3
    overflow: hidden
    img
      position: absolute
      width: 100%
  .word
    color: #666
    font-size: 14px
    h2
    h3
      margin-top: 12px
      margin-bottom: 5px
      font-weight: 700
    p
      line-height: 2
  .confirm
    display: block
    margin: 0 auto
    margin-top: 40px
    font-size: 14px
    text-align: center
    border-radius: 2px
    background-color: $primary3
    width: 160px
    padding: 6px 10px
    color: #fff
    cursor: pointer

// 重新申请弹窗
.reaudit
  width: 380px
  height: 390px
  background-color: #fff
  border-radius: 5px
  overflow: hidden
  display: flex
  flex-direction: column
  align-items: center
  .wrapper
    flex-grow: 1
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    padding: 35px 35px 55px
    .word
      font-size: 14px
      text-align: center
      color: #353535
    .confirm
      font-size: 14px
      text-align: center
      border-radius: 2px
      background-color: #be9d65
      width: 200px
      padding: 6px 10px
      color: #fff
      cursor: pointer
</style>
